import React, { useState } from 'react';
import { supabase } from '../supabase';
import { useAuth } from '../AuthContext';
import { C } from '../styles';
import { DropZone } from './DropZone';

// fileTypeField: 'content_type' for instruction_attachments, 'file_type' for variation_attachments
export function AttachmentUploader({ recordId, bucket, tableName, foreignKey, fileTypeField = 'file_type', onUploadSuccess, label = 'attachments' }) {
  const { profile } = useAuth();
  const [uploading, setUploading] = useState(false);
  const [uploadError, setUploadError] = useState(null);
  const [uploadSuccess, setUploadSuccess] = useState(null);

  async function handleFiles(files) {
    if (!files.length) return;

    setUploading(true);
    setUploadError(null);
    setUploadSuccess(null);

    const failed = [];
    const succeeded = [];

    for (const file of files) {
      try {
        const safeName = file.name.replace(/[^a-zA-Z0-9._-]/g, '_');
        const path = `${recordId}/${Date.now()}_${safeName}`;

        const arrayBuffer = await file.arrayBuffer();
        const { error: storageErr } = await supabase.storage
          .from(bucket)
          .upload(path, arrayBuffer, { contentType: file.type || 'application/octet-stream', upsert: false });

        if (storageErr) {
          console.error('Storage upload error:', storageErr);
          failed.push(`${file.name}: ${storageErr.message}`);
          continue;
        }

        const { error: dbErr } = await supabase.from(tableName).insert({
          [foreignKey]: recordId,
          uploaded_by: profile.id,
          file_name: file.name,
          file_size: file.size,
          [fileTypeField]: file.type || 'application/octet-stream',
          storage_path: path,
        });

        if (dbErr) {
          console.error('DB insert error:', dbErr);
          failed.push(`${file.name}: uploaded but DB insert failed — ${dbErr.message}`);
        } else {
          succeeded.push(file.name);
        }
      } catch (err) {
        console.error('Upload exception:', err);
        failed.push(`${file.name}: ${err.message}`);
      }
    }

    setUploading(false);

    if (failed.length > 0) setUploadError(`Failed: ${failed.join('; ')}`);
    if (succeeded.length > 0) {
      setUploadSuccess(`Uploaded: ${succeeded.join(', ')}`);
      if (onUploadSuccess) onUploadSuccess();
    }
  }

  return (
    <div>
      <DropZone
        onFilesSelected={handleFiles}
        disabled={uploading}
        accept=".pdf,.doc,.docx,.msg,.eml,.jpg,.jpeg,.png,.xlsx,.xls"
        multiple={true}
        label={label}
      />
      {uploadError && (
        <div style={{ color: C.danger, fontSize: '13px', marginTop: '8px', lineHeight: '1.5' }}>
          {uploadError}
        </div>
      )}
      {uploadSuccess && (
        <div style={{ color: C.success, fontSize: '13px', marginTop: '8px' }}>
          {uploadSuccess}
        </div>
      )}
    </div>
  );
}
